import React, { Fragment, useState } from 'react';
import { Modal, Button, Form, Message, Popup } from 'semantic-ui-react';
import config from '../../config';

function ChangePassword({ onClose }) {
  const [open, setOpen] = useState(true);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const onCloseHandler = () => {
    setOpen(false);
    onClose();
  };

  const isValid =
    currentPassword.length > 0 &&
    newPassword.length >= 8 &&
    newPassword === confirmPassword &&
    newPassword !== currentPassword;

  const newPasswordWarning =
    newPassword.length > 0 && newPassword.length < 8
      ? 'New password must be at least 8 characters.'
      : newPassword && newPassword === currentPassword
        ? 'New password must be different from the current password.'
        : null;

  const confirmPasswordWarning =
    newPassword && confirmPassword && newPassword !== confirmPassword
      ? 'Passwords do not match.'
      : null;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrMsg('');
    setSuccessMsg('');
    setLoading(true);
    try {
      const response = await fetch(`${config.apiURL}/onprem/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        credentials: 'include',
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccessMsg(data.detail || 'Password changed successfully');
        setTimeout(onCloseHandler, 1500);
      } else {
        setErrMsg(data.detail || 'Failed to change password');
      }
    } catch (err) {
      setErrMsg('Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        onClose={onCloseHandler}
        onOpen={() => setOpen(true)}
        open={open}
        size="mini"
      >
        <Modal.Header>
          Change Password
          <Button
            circular
            icon="close"
            title="Close"
            floated="right"
            onClick={onCloseHandler}
          />
        </Modal.Header>
        <Modal.Content>
          <Form onSubmit={onSubmit}>
            <Form.Input
              label="Current Password"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter your current password"
            />
            <Popup
              content={newPasswordWarning}
              open={!!newPasswordWarning}
              position="right center"
              style={{ color: '#9f3a38' }}
              trigger={
                <Form.Input
                  label="New Password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter a new password"
                />
              }
            />
            <Popup
              content={confirmPasswordWarning}
              open={!!confirmPasswordWarning}
              position="right center"
              style={{ color: '#9f3a38' }}
              trigger={
                <Form.Input
                  label="Confirm New Password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm your new password"
                />
              }
            />
            {successMsg && (
              <Message positive>
                <p>{successMsg}</p>
              </Message>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '1rem',
              }}
            >
              <Button onClick={onCloseHandler}>Cancel</Button>
              <Button
                type="submit"
                color="blue"
                disabled={!isValid}
                loading={loading}
              >
                Change Password
              </Button>
            </div>
          </Form>
        </Modal.Content>
        {errMsg !== '' && (
          <Message negative attached>
            <Message.Header>Error</Message.Header>
            <p>{errMsg}</p>
          </Message>
        )}
      </Modal>
    </Fragment>
  );
}

export default ChangePassword;
